import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';

@Component({
  selector: 'section[app-home-banner]',
  imports: [MatButtonModule, ShowleftDirective, RouterModule],
  templateUrl: './home-banner.html',
  styleUrl: './home-banner.scss',
})
export class HomeBanner {

  get newArrivalsNo(): string {
    return environment.collection.new_arrivals;
  }
}
